import { useEffect, useRef } from 'react';
import { useLocale } from 'next-intl';

//* Components
import Text from '@/components/Text';
import Icon from '@/components/Icon';
import Container from '@/components/Container';
import CustomLink from '@/components/CustomLink';
import useTrigger from '@/components/Animation/useTrigger';

//* Styles
import ServiceContentStyle from './style';

//* Data
import { dataService } from '@/data';

const ServiceContent = () => {
	const lang = useLocale();

	//! Refs
	const refWrapper = useRef();
	const serviceCategory = useRef([]);
	const styleRef = useRef();

	useEffect(() => {
		const cleanups = serviceCategory.current.map((item) => {
			return useTrigger({
				documentPercent: 80,
				ref: item,

				onEnter: () => {
					item.parentElement.classList.add('active');
				},
			});
		});

		return () => {
			cleanups.forEach((cleanup) => {
				cleanup();
			});
		};
	}, [serviceCategory]);

	return (
		<ServiceContentStyle ref={styleRef}>
			<Container isSection>
				<div
					ref={refWrapper}
					className='inner-wrapper-service-content'>
					{dataService[lang].item.map((item, i) => {
						return (
							<div
								className='every-service-wrapper'
								key={item.url}>
								<div className={`wrapper-service-title`}>
									<Text
										tag={i == 0 ? 'h1' : 'h2'}
										className={'font-montserrat-arm-medium h3 uppercase text-category-title'}>
										{item.title}
									</Text>
									<div className={`ever-vertical-line ${item.content.length > 1 ? (item.content.length % 2 ? 'even' : 'odd') : ''}`}></div>
								</div>

								{item.content.length > 1 && (
									<div
										style={{ '--horizontalLineDelta': `${item.content.length}` }}
										className={`line-horizontal`}></div>
								)}
								<div
									ref={(el) => (serviceCategory.current[i] = el)}
									className='wrapper-content'>
									{item.content.map((elem, index, arr) => {
										return (
											<div
												key={index}
												className='every-content'>
												{arr.length > 1 ? (
													arr.length % 2 === 0 || index !== Math.floor(arr.length / 2) ? (
														<div
															className={`ever-vertical-line inner-line`}
															style={{ '--delayMobile': `${0.3 * index}s` }}></div>
													) : (
														<div
															className='ever-vertical-line empty'
															style={{ '--delayMobile': `${0.3 * index}s` }}></div>
													)
												) : null}

												<div className='wrapper-link-item'>
													<CustomLink
														url={elem.url}
														className={'align-center'}
														style={{ '--delayMobile': `${0.3 * index}s` }}>
														<Text
															className={'font-montserrat-arm-medium title'}
															style={{ '--delayMobile': `${0.3 * index}s` }}>
															{elem.title}
														</Text>

														<Icon name={'arrowRight'} />
													</CustomLink>
												</div>
											</div>
										);
									})}
								</div>
							</div>
						);
					})}
				</div>
			</Container>
		</ServiceContentStyle>
	);
};

export default ServiceContent;
